<div class="pw-svc">
    <svg width="0" height="0" style="display: none; visibility:hidden;">
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="pw_load_close">
            <path d="M0 0h24v24H0V0z" fill="none"></path>
            <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z">
            </path>
        </symbol>
    
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="pw_load_expand_more">
            <path d="M24 24H0V0h24v24z" fill="none" opacity=".87"></path>
            <path
                d="M15.88 9.29L12 13.17 8.12 9.29c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z">
            </path>
        </symbol>
    
        <symbol xmlns="http://www.w3.org/2000/svg" fill="#0078D4" viewBox="0 0 32 32" id="pw_load_logo">
            <rect width="2.31884" height="32" rx="1.15942"></rect>
            <rect x="3.70996" width="2.31884" height="32" rx="1.15942"></rect>
            <rect x="7.41992" width="2.31884" height="32" rx="1.15942"></rect>
            <rect x="11.1309" y="4.85318" width="2.31884" height="15.0142" rx="1.15942"></rect>
            <path
                d="M14.8408 10.5404C14.8408 9.91223 15.3599 9.40298 16.0002 9.40298C16.6406 9.40298 17.1597 9.91223 17.1597 10.5404V22.9764C17.1597 23.6046 16.6406 24.1139 16.0002 24.1139C15.3599 24.1139 14.8408 23.6046 14.8408 22.9764V10.5404Z">
            </path>
            <rect x="18.5508" y="13.346" width="2.31884" height="15.1659" rx="1.15942"></rect>
            <rect x="22.2607" width="2.31884" height="32" rx="1.15942"></rect>
            <rect x="25.9707" width="2.31884" height="32" rx="1.15942"></rect>
            <rect x="29.6816" width="2.31884" height="32" rx="1.15942"></rect>
        </symbol>
    
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="pw_load_left">
            <path d="M0 0h24v24H0V0z" fill="none"></path>
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"></path>
        </symbol>
    
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="pw_load_right">
            <path d="M0 0h24v24H0V0z" fill="none"></path>
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"></path>
        </symbol>
    
        <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 294 30" id="pw_load_wave">
            <line x1="1.25" y1="6.25" x2="1.25" y2="24.75" stroke="url(#paint0_linear_5722_91827)" stroke-width="2.5" stroke-linecap="round"></line>
            <line x1="10.25" y1="11.25" x2="10.25" y2="21.75" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></line>
            <line x1="18.25" y1="14.25" x2="18.25" y2="19.75" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></line>
            <line x1="26.25" y1="15.25" x2="26.25" y2="18.75" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></line>
            <path d="M34.25 11.25L34.25 19.75" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M42 8L42 23" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M52 2V28" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M60 7V23" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M69 10V21" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M77 13V20" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M85 14V17" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M94 11V20" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M102 7V23" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M111 13V20" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M120 12V17" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M129 11V16" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M138 7V23" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M147 2V28" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M156 8V21" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M165 11V20" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M174 13V17" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M183 11L183 17" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M191 7L191 23" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M199 11L199 20" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M208 13L208 17" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M217 13L217 17" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M225 10L225 20" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M233 6L233 26" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M242 2L242 28" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M252 7L252 23" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M260 10L260 20" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M268 13L268 23" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M276 13L276 21" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M284 11L284 19" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M292 7L292 26" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round"></path>
            <defs>
              <linearGradient id="paint0_linear_5722_91827" x1="-4.5897e-07" y1="15.5" x2="-1" y2="15.5" gradientUnits="userSpaceOnUse">
                <stop stop-color="#ffffff"></stop>
                <stop offset="1" stop-color="#ffffff" stop-opacity="0"></stop>
              </linearGradient>
            </defs>
        </symbol>

        <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 294 30" id="pw_load_wave_d">
            <line x1="1.25" y1="6.25" x2="1.25" y2="24.75" stroke="url(#paint0_linear_5722_91827)" stroke-width="2.5" stroke-linecap="round"></line>
            <line x1="10.25" y1="11.25" x2="10.25" y2="21.75" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></line>
            <line x1="18.25" y1="14.25" x2="18.25" y2="19.75" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></line>
            <line x1="26.25" y1="15.25" x2="26.25" y2="18.75" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></line>
            <path d="M34.25 11.25L34.25 19.75" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M42 8L42 23" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M52 2V28" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M60 7V23" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M69 10V21" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M77 13V20" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M85 14V17" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M94 11V20" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M102 7V23" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M111 13V20" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M120 12V17" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M129 11V16" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M138 7V23" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M147 2V28" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M156 8V21" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M165 11V20" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M174 13V17" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M183 11L183 17" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M191 7L191 23" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M199 11L199 20" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M208 13L208 17" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M217 13L217 17" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M225 10L225 20" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M233 6L233 26" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M242 2L242 28" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M252 7L252 23" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M260 10L260 20" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M268 13L268 23" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M276 13L276 21" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M284 11L284 19" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <path d="M292 7L292 26" stroke="#000000" stroke-width="2.5" stroke-linecap="round"></path>
            <defs>
              <linearGradient id="paint0_linear_5722_91827" x1="-4.5897e-07" y1="15.5" x2="-1" y2="15.5" gradientUnits="userSpaceOnUse">
                <stop stop-color="#ffffff"></stop>
                <stop offset="1" stop-color="#ffffff" stop-opacity="0"></stop>
              </linearGradient>
            </defs>
        </symbol>
    
        <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 74" id="nr_LLM_play">
            <g id="Group 1321314370">
            <g id="Ellipse 5911" filter="url(#filter0_b_485725_2142)">
                <circle cx="37.2537" cy="37.2537" r="36.2537" fill="white" fill-opacity="0.6"></circle>
                <circle cx="37.2537" cy="37.2537" r="36.2537" stroke="black" stroke-opacity="0.6" stroke-width="0.5"></circle>
            </g>
            <path id="Polygon 1" d="M55.7686 33.9846C58.4111 35.5288 58.4111 39.3475 55.7686 40.8917L30.8887 55.4309C28.2221 56.9892 24.8705 55.0659 24.8705 51.9773L24.8705 22.899C24.8705 19.8105 28.2221 17.8872 30.8887 19.4455L55.7686 33.9846Z" fill="black" fill-opacity="0.6" stroke="black" stroke-opacity="0.6" stroke-width="0.5"></path>
            </g>
            <defs>
            <filter id="filter0_b_485725_2142" x="-39.25" y="-39.25" width="153.007" height="153.007" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"></feGaussianBlur>
                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_485725_2142"></feComposite>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_485725_2142" result="shape"></feBlend>
            </filter>
            </defs>
        </symbol>

        <symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75 75" id="nr_LLM_pause">
            <g filter="url(#filter0_b_485725_2137)">
            <circle cx="37.2537" cy="37.2537" r="36.2537" fill="white" fill-opacity="0.6"></circle>
            <circle cx="37.2537" cy="37.2537" r="36.2537" stroke="#0078D4" stroke-width="2"></circle>
            </g>
            <rect x="40" y="18" width="9" height="37" rx="2" fill="#0078D4"></rect>
            <rect x="26" y="18" width="9" height="37" rx="2" fill="#0078D4"></rect>
            <defs>
            <filter id="filter0_b_485725_2137" x="-40" y="-40" width="154.507" height="154.507" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"></feGaussianBlur>
                <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_485725_2137"></feComposite>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_485725_2137" result="shape"></feBlend>
            </filter>
            </defs>
        </symbol>
        
    </svg>
    
    <audio id="pw-voice-preview" src="" preload="none" style="display: none; visibility:hidden;"></audio>
    
    <div class="pw-voice-page" id="pw-voice-page">
        <div class="pw-voice-header">
            <div class="pw-voices-control">
                <!-- <svg class="pw-voice-logo">
                    <use xlink:href="#pw_load_logo"></use>
                </svg> -->
                <button id="pw-load-close" class="nr-btn nr-btn-icon pw-load-close" aria-label="close voice-load page" (click)="lazyLoadMainComponent()">
                    <svg>
                        <use xlink:href="#pw_load_close"></use>
                    </svg>
                </button>
                <div class="pw-voice-title">Welcome to NaturalReader</div>
                
            </div>
    
            <div class="pw-voices-row">
                <!-- <p class="pw-voice-title">Choose one favorite voice</p> -->
                <div class="pw-voices-select">
                    <svg class="pw-voices-select-arrow">
                        <use xlink:href="#pw_load_expand_more"></use>
                    </svg>
                    <select name="pw_languages" id="pw_languages" aria-label="choose voice language">
                    </select>
                    <span class="focus"></span>
                </div>
            </div>
        </div>
    
        <div class="pw-voice-content">
            <button class="nr-btn nr-btn-icon" id="voice-prev" aria-label="prev voice item">
                <svg>
                    <use xlink:href="#pw_load_left"></use>
                </svg>
            </button>
    
            <div class="pw-voice-list" id="pw-free-list">
                
                <!-- <button class="nr-btn nr-voice-card" id="comm-Multi-Lingual-Adam">
                    <div class="nr-voice-icon">
                        <img class=" lazyloaded"
                            data-src="https://wwwnaturalreaderscom.s3.amazonaws.com/comm2022-portraits/el/Adam.jpg" alt=""
                            src="https://wwwnaturalreaderscom.s3.amazonaws.com/comm2022-portraits/el/Adam.jpg">
                        <div class="nr-voice-flag">
                            <svg class="nr-voice-play">
                                <use xlink:href="#nr_LLM_play"></use>
                            </svg>
                            <svg class="nr-voice-pause">
                                <use xlink:href="#nr_LLM_pause"></use>
                            </svg>
                        </div>
                    </div>
                    <div class="nr-voice-info">
                        <div class="nr-voice-name">Adam</div>
                        <div class="nr-voice-wave">
                            <svg class="nr-voice-speaker">
                                <use xlink:href="#nr_volume"></use>
                            </svg>
                            <svg class="nr-play-wave">
                                <use xlink:href="#pw_load_wave"></use>
                            </svg>
                        </div>
                    </div>
                </button> -->
            </div>
    
            <button class="nr-btn nr-btn-icon" id="voice-next" aria-label="next voice item">
                <svg>
                    <use xlink:href="#pw_load_right"></use>
                </svg>
            </button>
        </div>
    
        <div class="pw-voice-footer">
            <button [disabled]="actionButtonText=='Loading'" class="nr-btn btn-flat-blue" (click)="nextButtonOnClick()" aria-label="next to NaturalReader online content">
                {{actionButtonText}}
            </button>
        </div>
    
        <div class="pw-svc-seo" id="pw-svc-seo">
            <div>What is text to speech?</div>
            <p>
                Text to speech (TTS) is a technology that converts text into spoken audio. It can read aloud PDFs, websites, and books using natural AI voices.
            </p>
            <p>
                Text-to-speech (TTS) technology can be helpful for anyone who needs to access written content in an auditory format, and it can provide a more inclusive and accessible way of communication for many people.
            </p>
            <p>
                Some of the latest developments in text-to-speech technology include AI Neural TTS, Expressive TTS, and Real-time TTS. 
            </p>
            <div>What does TTS mean?</div>
            <p>
                TTS stands for Text-to-Speech (TTS), also referred to as speech synthesis, a transformative technology that uses artificial intelligence (AI) to convert written text into incredibly lifelike spoken words. TTS systems play a vital role in improving accessibility, particularly for individuals with learning disabilities and visual impairments, as they can have any text read aloud.
            </p>
            <div>What Languages Does NaturalReader Support?</div>
            <p>
                NaturalReader is proud to support 99+ Languages. Our AI text-to-speech applications can naturally read aloud text in English, Afrikaans, Arabic, Armenian, Azerbaijani, Belarusian, Bosnian, Bulgarian, Catalan, Chinese, Croatian, Czech, Danish, Dutch, English, Estonian, Finnish, French, Galician, German, Greek, Hebrew, Hindi, Hungarian, Icelandic, Indonesian, Italian, Japanese, Kannada, Kazakh, Korean, Latvian, Lithuanian, Macedonian, Malay, Marathi, Maori, Nepali, Norwegian, Persian, Polish, Portuguese, Romanian, Russian, Serbian, Slovak, Slovenian, Spanish, Swahili, Swedish, Tagalog, Tamil, Thai, Turkish, Ukrainian, Urdu, Vietnamese, and Welsh.
                To view our complete language list, please visit: <a href="https://help.naturalreaders.com/en/articles/8823770-voices-languages-and-tts-limits-personal-version#h_ec567bee63" target="_blank">https://help.naturalreaders.com/en/articles/8823770-voices-languages-and-tts-limits-personal-version#h_ec567bee63</a>
            </p>
        </div>
    </div>


    <div class="pw-comm-info pw-scv-hidden" id="pw-comm-info">
        <div class="pw-comm-logo">
            <svg class="pw-comm-logo">
                <use xlink:href="#pw_load_logo"></use>
            </svg>
            <span>aturalReader</span>
        </div>

        <div class="pw-comm-switch" id="pw-comm-switch">
            <div class="comm-switch-card pw-card" id="switch-pw-card" (click)="chooseUseage('switch-pw-card')">
                <div class="switch-card-title">For Personal Use</div>
                <div class="switch-card-info">
                    <p>Perfect for Individuals:</p>
                    <p>Students, Reading, Dyslexia</p>
                </div>
                <a class="nr-btn" (click)="lazyLoadMainComponent(); changePwBtnText()">
                   {{pwBtnText}}
                </a>
            </div>

            <div class="comm-switch-card comm-card" id="switch-comm-card" (click)="chooseUseage('switch-comm-card')">
                <div class="switch-card-title">For Commercial Use</div>
                <div class="switch-card-info">
                    <p>Perfect for Businesses:</p>
                    <p>Videos, eLearning, Youtube</p>
                </div>
                <a class="nr-btn" (click)="goToComm()">
                    go to A.I. VOICE GENERATOR
                </a>
            </div>
        </div>

        <div class="pw-comm-seo">
            <div>
                <div>
                    What is the difference between the personal and commercial use?
                </div>
                <p>
                    Personal use means that only you as the license holder may use the audio files for your own private use. It does not allow you to share or redistribute the audio content in any way, such as using the audio for YouTube, training videos, social media, blogs/personal websites, etc. NaturalReader AI Text to Speech (Premium, Plus, and EDU plans) are for personal use only. <br>
                    NaturalReader AI Voice Generator is the only version that allows you to use the audio content for commercial or public use. This includes, but is not limited, to: YouTube, training videos, social media, eLearning, IVR systems, broadcasts, public announcements, etc.
                </p>
            </div>

            <div>
                <div>
                    Do you have any products for educational use?
                </div>
                <p>
                    NaturalReader EDU provides personal use Group or Site Licenses for K12 schools, universities, colleges, and other institutions.<br>
                    If you are a teacher or administrator, you can get more information from:<br>
                    <a href="https://www.naturalreaders.com/edu.html" target="_blank">https://www.naturalreaders.com/edu.html</a><br>
                    Students can select "Personal Use" to use the EDU version.
                </p>
            </div>
        </div>
    </div>
</div>

